import React from "react"
import { Link } from "gatsby"

const FreeDemoBar = props => {
  const qwery = props.data
  return (
    // <div className="mb-12 min-h-[65px] py-10">
    <div className=" mx-auto relative md:justify-around items-center mb-5">
      {/* <p className={`${props.text === null ? "border border-[red]" :" text-edc-dark-blue text-left font-sans lg:text-[18px] text-[16px] lg:px-0 px-4 font-normal"}`}>
          {props.text ? props.text : qwery.barText}
        </p> */}
      <Link
        to={
          qwery.demoRequestPage
            ? "/" + qwery.demoRequestPage.slug
            : qwery.referenceToPage.slug
        }
        className="bg-[#006ef5] absolute text-white !px-6 !py-4 !rounded-full font-sans mt-5 md:mt-0 !font-medium shadow-[10px_10px_25px_0px_rgba(237,193,31,0.6)] hover:shadow-md hover:underline"
      >
        {qwery.extraBlocks
          ? qwery.extraBlocks[0].buttonText
          : qwery.barButtonText}
      </Link>
    </div>
    // </div>
  )
}

export default FreeDemoBar
